(() => {
	angular.module('main').controller('QuoteViewController', QuoteViewController);

	QuoteViewController.$inject = [
		'$scope',
		'$rootScope',
		'$routeParams',
		'$location',
		'$http',
		'$sce',
		'$timeout',
		'$window',
		'messageService',
		'fileUploadService',
		'jobDataService',
		'timeService',
		'validationService',
		'emailService',
		'userService',
		'leadDataService',
		'newJobsDataService',
		'templateRequestsService',
		'invoicesDataService',
		'quotesDataService'
	];

	function QuoteViewController(
		$scope,
		$rootScope,
		$routeParams,
		$location,
		$http,
		$sce,
		$timeout,
		$window,
		messageService,
		fileUploadService,
		jobDataService,
		timeService,
		validationService,
		emailService,
		userService,
		leadDataService,
		newJobsDataService,
		templateRequestsService
	) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.quoteId = $routeParams.quoteId;
			$scope.jobId = $routeParams.jobId;
			$scope.leadId = $routeParams.leadId;
		});

		$scope.sendMessage = {};
		clearAttachments();

		$scope.toggleViewCc = function(state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = '';
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;

			if (state === false) {
				clearAttachments();
			}
		};

		// Email methods
		$scope.retrySendMail = function() {
			snCommunicationAdapter.callMethod('updateQuoteViewData');
			emailService.callLastEmailFn();
		};

		$scope.showSendQuote = function(data) {
			$scope.contactEmail = data.email;
			$scope.jobId = data.jobId;

			$scope.sendMessage = {};

			templateRequestsService.getTemplates('all').subscribe(data => {
				if (data) {
					$scope.emails = data;

					if (data.length > 0) {
						$scope.choosenEmail =
							$scope.emails.find(
								item => item.emailTemplateType === 'QUOTE_EMAIL_TEMPLATE'
							) || {};
					}
					$scope.$evalAsync();

					$('#sendQuoteModal')
						.modal('show')
						.on('shown.bs.modal', () => {
							const input = $('#sendQuoteModal').find('input');
							const select = $('#sendQuoteModal').find('select');

							validationService.isModalClosePrevented(input);
							validationService.isModalClosePrevented(select);
						});
				}
			});
		};

		$scope.$watch('choosenEmail', newValue => {
			if (typeof newValue !== 'undefined' && newValue !== '') {
				templateRequestsService
					.getTemplates('full_template', newValue.id)
					.subscribe(data => {
						if (data) {
							$scope.sendMessage.emailSubject = data.subject;
							$scope.sendMessage.emailText = data.text;

							if (data.storedAttachments && data.storedAttachments.length) {
								$scope.attachmentsData = {
									attachments: fileUploadService.convertAttachmentsToShow(
										data.storedAttachments
									)
								};
							} else {
								clearAttachments();
							}

							const rootEmail = $rootScope.primaryContact
								? $rootScope.primaryContact.email || ''
								: '';
							$scope.sendMessage.emailTo = $scope.contactEmail || rootEmail;
							$scope.sendMessage.emailCc = '';

							$scope.sendMessage.emailCc =
								angular.element('#sendQuoteMessageData_emailCc').val() || '';
						}
					});
			}
		});

		function clearAttachments() {
			$scope.attachmentsData = {
				attachments: [],
				filesSize: 0
			};
		}

		let clientsEmailTimer;
		$scope.clientEmails = [];

		function emailSearchRequest(search) {
			jobDataService
				.searchClient(search)
				.then(result => findClientSuccessCallback(result.data))
				.catch(messageService.showDefaultErrorMessage);
		}

		function findClientSuccessCallback(client) {
			if (client) {
				$scope.clientEmails.length = 0;
				client.forEach(item => $scope.clientEmails.push(item));
			}
		}

		// TREBA

		$scope.sendQuote = function() {
			const maxSize = 10; // 10Mb

			if (
				$scope.attachmentsData &&
				$scope.attachmentsData.filesSize > maxSize
			) {
				messageService.showToaster('w_0', 'attachments');
				$scope.isSentSpinnningWheelActive = false;
				return false;
			}

			$scope.sendMessage.templateId = $scope.choosenEmail
				? $scope.choosenEmail.id
				: null;
			$scope.sendMessage.emailText = $rootScope.addMaiStyling(
				$scope.sendMessage.emailText
			);

			$scope.sendMessage.jobId = $scope.jobId;
			$scope.sendMessage.quoteId = $routeParams.quoteId;

			const obj2save = angular.copy($scope.sendMessage);
			$scope.sendMessage.emailCc = $scope.showCcField ? obj2save.emailCc : '';

			const quoteEmail = $scope.sendMessage;

			const formData = new FormData();
			angular.forEach(quoteEmail, (value, key) => {
				console.debug(`key: ${key}  | value: ${value}`);
				formData.append(key, value);
			});

			const filesFromJob = $scope.attachmentsData.attachments.filter(
				file => file.id
			);
			const filesFromComputer = $scope.attachmentsData.attachments.filter(
				file => !file.id
			);

			angular.forEach(filesFromComputer, (value, key) => {
				formData.append(`attachments[${key}]`, value);
			});

			angular.forEach(filesFromJob, (value, key) => {
				formData.append(`storedAttachments[${key}]`, value.id);
			});

			$scope.disableBtnOnSend = true;
			$http({
				method: 'POST',
				url: '/protected/rest/jobs/quote/send/',
				data: formData,
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined
				}
			})
				.then(result => successSendInvoice(result.data))
				.catch(errorSendQuote);
		};

		function successSendInvoice(data) {
			$scope.$evalAsync();
			$('#sendQuoteModal').modal('hide');

			$scope.disableBtnOnSend = false;
			$scope.showCcField = false;

			$scope.$evalAsync();

			clearAttachments();

			if ($rootScope.updateJobView) {
				$rootScope.updateJobView();
			} else if ($rootScope.updateLeadView) {
				$rootScope.updateLeadView();
			}

			messageService.showToaster('s_10', 'payments');

			snCommunicationAdapter.callMethod('updateQuoteViewData');
		}

		function errorSendQuote({ status, data }) {
			$scope.disableBtnOnSend = false;
			const errorMessage = data.errorMessage;
			const path = $location.path();

			if (status >= 400 && status < 500 && errorMessage) {
				if (status == 423) {
					const limit = $rootScope.isUserTrial ? 50 : 150;
					return messageService.showToaster('e_4', 'generalValidation', limit);
				} else if (errorMessage.includes('Email address inactive')) {
					messageService.showToaster(
						'e_1',
						'generalValidation',
						$scope.sendMessage.emailTo
					);
				} else if (
					errorMessage.includes('Email text should contain a quote link')
				) {
					messageService.showToaster('e_3', 'editQuote');
				} else if (errorMessage.includes('Lead is archived')) {
					messageService.showToaster('e_5', 'lead');
				} else if (path.includes('jobs') || path.includes('leads')) {
					messageService.showToaster('e_3', 'editQuote');
				} else {
					messageService.showToaster('e_2', 'general', errorMessage);
				}
			} else {
				messageService.showToaster('e_0', 'general');
			}
		}

		$scope.setEmail = function(site) {
			let stringEmail = angular.copy(site.name);
			stringEmail = stringEmail.substring(
				stringEmail.indexOf('(') + 1,
				stringEmail.length - 1
			);

			$scope.sendMessage.emailCc = stringEmail;
			$scope.emailCcObj = Object.assign({ email: stringEmail }, site);
		};

		$scope.$watchCollection('sendMessage', newValue => {
			if (newValue) {
				if (!newValue.emailCc) {
					$scope.sendMessage.emailCc =
						angular.element('#sendQuoteMessageData_emailCc').val() || '';
				}

				if (
					$scope.sendMessage &&
					$scope.sendMessage.emailCc &&
					$scope.sendMessage.emailCc.length > 0
				) {
					if (clientsEmailTimer != null) {
						clearTimeout(clientsEmailTimer);
					}

					clientsEmailTimer = setTimeout(
						emailSearchRequest($scope.sendMessage.emailCc),
						500
					);
				} else {
					clearTimeout(clientsEmailTimer);
				}
			}
		});

		$scope.disableDragDrop = function() {
			return true;
		};

		$(document).on('show.bs.modal', '#sendQuoteModal', () => {
			$scope.$broadcast('addedFileEvent');
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/quoteViewController.js